import api from 'config/axios';
import AppService from 'common/app-service';
import { ICommentData } from 'common/comment.interface';

export default class CommentsService extends AppService {
  constructor() {
    super('comments', api);
  }

  async saveComment(commentData: ICommentData): Promise<any> {
    const response = await this.api.post(this.root(), commentData);

    return response.data;
  }
}
